import * as net from 'util/Net';

const MetadataDAO = {
  bulkUpdateTagSchema(fileIds: Array<string>, tagSchemaId: string | null, deleteOldSchemaTags: boolean) {
    return net.postJSON({
      url: '/1/api/files/bulk-set-tag-schema',
      data: {
        fileIds,
        tagSchemaId,
        deleteOldSchemaTags,
      },
    });
  },
};

export default MetadataDAO;
